import { render } from "./AssemblyProduceAchievementArea.vue?vue&type=template&id=38172b68&scoped=true"
import script from "./AssemblyProduceAchievementArea.vue?vue&type=script&lang=js"
export * from "./AssemblyProduceAchievementArea.vue?vue&type=script&lang=js"

import "./AssemblyProduceAchievementArea.vue?vue&type=style&index=0&id=38172b68&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38172b68"]])

export default __exports__